import { render, staticRenderFns } from "./infoTable.vue?vue&type=template&id=d721ba08&scoped=true"
import script from "./infoTable.vue?vue&type=script&lang=js"
export * from "./infoTable.vue?vue&type=script&lang=js"
import style0 from "./infoTable.vue?vue&type=style&index=0&id=d721ba08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721ba08",
  null
  
)

export default component.exports